<ul>
  <li>
    <div class="title">{{ contentTitle() }}</div>
    <div class="progression">
      <div class="percent">{{ completionPercent() }}%</div>
      <p class="status" translate>common.status.in_progress</p>
    </div>
  </li>

  <li>
    <div class="data">{{ distance() }}</div>
    <div class="label">
      <app-icon [size]="2" icon="distance" />
      <p translate>common.metric.distance.long</p>
    </div>
  </li>

  <li>
    <div class="data">{{ duration() }}</div>
    <div class="label">
      <app-icon [size]="2" icon="timer" />
      <p translate>common.metric.duration.long</p>
    </div>
  </li>

  <li>
    <div class="data">{{ speedAvr() }}</div>
    <div class="label">
      <app-icon [size]="2" icon="speed" />
      <p translate>common.metric.speed.avg</p>
    </div>
  </li>

  @if (sport() !== 'rowing') {
    <li>
      <div class="data">{{ elevation() }}</div>
      <div class="label">
        <app-icon [size]="2" icon="slope" />
        <p translate>common.metric.elevation.long</p>
      </div>
    </li>
  } @else {
    <li>
      <div class="data">
        {{ cadenceAvr() }}{{ 'common.metric.cadence.short' | translate | uppercase }}
      </div>
      <div class="label">
        <app-icon [size]="2" icon="slope" />
        <p translate>common.metric.pace.avg</p>
      </div>
    </li>
  }
</ul>

<div class="content">
  <app-icon [size]="5" icon="pause" />
  <p class="pause">{{ 'common.status.pause' | translate | uppercase }}</p>
  @if (message()) {
    <p class="message">{{ message() }}</p>
  }
</div>
